module.exports = __webpack_public_path__ + "static/media/arrow-up-right.5ed540d5.svg";